import SwiperCore, {Autoplay, EffectFade, Navigation, Pagination} from "swiper";
import {Route, Switch, useRouteMatch} from "react-router";
import {CpOrderCarPage} from "./cpOrderCar";
import NotFoundPage_404 from "../_errors/404";

SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade,]);

export function ControlPanelPage() {
    const {path, url} = useRouteMatch();
    return (
        <div className={"control-panel-page mx-10 mb-"}>

            <div className={"control-panel-page-content"}>
                <Switch>
                    {/* SalesClientEnquiries */}
                    <Route exact path={`${path}`} component={CpOrderCarPage}/>
                    <Route exact path={`${path}/sales-enquiries`} component={CpOrderCarPage}/>
                    <Route exact path={`${path}/sales-enquiries/`} component={CpOrderCarPage}/>

                    <NotFoundPage_404/>

                </Switch>
            </div>
        </div>
    );
}